import React, { useState } from "react";
import { Button, Field, Textarea } from "@fluentui/react-components";
import services from "../../services/indexService";
import { useTaskPane } from "../../provider/TaskPaneProvider";
import useToast from "../../hooks/useToast";
import { appInsights } from "../../../telemetry/telemetryService";

const AddNote = ({ handleCloseAddNotes, handleSubmitAddNotes }) => {
  const { Toaster, notify } = useToast();
  const [note, setNote] = useState(null);
  const {
    taskPaneState,
    profileDetails,
    selectedItemDetailFromGrid
  } = useTaskPane();

  const handleNote = (e) => {
    console.log(e.target.value);
    setNote(e.target.value);
  }

  console.log('taskPaneState', taskPaneState);
  console.log('profileDetails', profileDetails);

  const handleSave = async (e) => {
    // e.stoppropagation();
    console.log('e', e);
    try {
      notify("progress");
      const result = await services.addNotes({
  "incidentID": null,
  "insuredID": null,
  "appMasterID": null,
  "providerID": null,
  "producerID": null,
  "finContractID": null,
  "important": true,
  "permanentNote": true,
  "accountingUser": true,
  "campaignID": null,
  "noteTypeID": null,
  "displayOnPolicy": true,
  "naicid": null,
        compLocID: +selectedItemDetailFromGrid?.compLocID,
        policyID: selectedItemDetailFromGrid?.policyID,
        modUserID: taskPaneState?.userId,
        note
      }); // 6761744
      notify("success", "Notes data fetch successful!");
      handleSubmitAddNotes();
    } catch (e) {
      notify("error", "Failed to fetch Notes data");
      console.log(e);
      appInsights.trackDependencyData({
          target: process.env.BASE_URL,
          name: "Word_addNotes_Payload",
          dependencyTypeName: "HTTPS",
          success: false,
          responseCode: e?.status || 500,
          properties: {
            bodyData: {
              compLocID: +selectedItemDetailFromGrid?.compLocID,
              policyID: selectedItemDetailFromGrid?.policyID,
              modUserID: taskPaneState?.userId,
              note
            },
            error: e,
            userId: taskPaneState.userId
          }
        });
    }
  }
  return (
    <div>
      <h2 className="h2-text text-xl font-bold mb-4">Add Notes</h2>
      {Toaster}
      <Field label={"Notes"}>
        <Textarea onChange={handleNote} style={{borderBottomColor:'#d1d5db', outline:'none'}}></Textarea>
      </Field>
      <div className="flex justify-end gap-2 mt-2">
        <Button 
       className={`${(!note)? "btn-com-disable": "btn-com"}`}
        disabled={!note} 
        onClick={handleSave}>Add</Button>
        <Button 
          className="btn-com-cancel"
        onClick={handleCloseAddNotes}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default AddNote;
